import { CrownOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, ConfigProvider, DatePicker, Form, Input, Pagination, PaginationProps, Select, Switch, TableColumnsType, Tabs, Tooltip } from 'antd';
import { SearchProps } from 'antd/es/input';
import { useForm } from 'antd/lib/form/Form';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as BenefitApi from '../../../api/rank/benefitApi';
import * as RankApi from '../../../api/rank/rankApi';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import { dataPagination, fommatSelectOption, formatDateV2, handleStringToDayJsV2 } from '../../../until';
import './AddRank.scss';
import TierBenefits from './ComponentAddRank/TierBenefits';

import { formatNumber } from '../../../services/mixin';

import viVN from 'antd/locale/vi_VN';
import { useSelector } from 'react-redux';
import { getCLCategoryCar, getSLChildListCar } from '../../../api/selectOption/selectOptionsApi';
import { ISelectOption } from '../../../api/selectOptions/selectOptionsApi';
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice';

const { Search } = Input;

const EditPolicyManagement: React.FC = () => {
  const [form] = useForm()
  const navigator = useNavigate()
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const brand = Form.useWatch("brand", form);

  const [valueNumber, setValueNumber] = useState<string>('');
  const [listBenefits, setListBenefits] = useState<number[]>([])
  const [listBenefitPolicies, setListBenefitPolicies] = useState<number[]>([])
  const location = useLocation()
  const { id } = location?.state ?? {}
  const pushToast = useToast();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [dataBenefit, setDataBenefit] = useState<BenefitApi.DataTypeBenefit[]>([])

  const [searchValue, setSearchValue] = useState<string>('');

  const [dataBenefitPolicies, setDataBenefitPolicies] = useState<BenefitApi.DataTypeBenefit[]>([])
  const [searchValuePolicies, setSearchValuePolicies] = useState<string>('');
  const [paginationPolicies, setPaginationPolicies] = useState({ current: 1, pageSize: 20, total: 0 });


  const [cLCategoryCar, setCLCategoryCar] = useState<ISelectOption[]>([])
  const [cLListCar, setCLListCar] = useState<ISelectOption[]>([])

  const [valueTab, setValueTab] = useState<string>('2');

  const isAllSelected = dataBenefit.length > 0 && listBenefits.length === dataBenefit.length;

  const handleSwitchChange = (checked: boolean, key: number) => {
    if (checked) {
      setListBenefits(prev => [...prev, key]);
    } else {
      setListBenefits(prev => prev.filter(id => id !== key));
    }
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setListBenefits(dataBenefit.map(item => item.key as number));
    } else {
      setListBenefits([]);
    }
  };

  const isAllSelectedPolicies = dataBenefitPolicies.length > 0 && listBenefitPolicies.length === dataBenefitPolicies.length;

  const handleSwitchChangePolicies = (checked: boolean, key: number) => {
    if (checked) {
      setListBenefitPolicies(prev => [...prev, key]);
    } else {
      setListBenefitPolicies(prev => prev.filter(id => id !== key));
    }
  };

  const handleSelectAllPolicies = (checked: boolean) => {
    if (checked) {
      setListBenefitPolicies(dataBenefitPolicies.map(item => item.key as number));
    } else {
      setListBenefitPolicies([]);
    }
  };


  const columns: TableColumnsType<BenefitApi.DataTypeBenefit> = [
    {
      title: () => (
        <Switch
          size='small'
          checked={isAllSelected}
          onChange={handleSelectAll}
        />
      ),
      dataIndex: 'key',
      align: 'center',
      render: (key: number) => (
        <Switch
          size='small'
          checked={listBenefits.includes(key)}
          onChange={(checked) => handleSwitchChange(checked, key)}
        />
      ),
    },
    // {
    //   title: 'STT',
    //   dataIndex: 'stt',
    //   align: 'center',
    //   sorter: {
    //     compare: (a, b) => a.stt - b.stt,
    //     multiple: 1,
    //   },
    // },
    {
      title: 'Mã quyền lợi',
      dataIndex: 'code',
      render: (text) => (
        <div className="t-name-ql">
          <span className="neutral-gray-500 text-2-row">{text}</span>
        </div>
      ),
    },
    {
      title: 'Tên quyền lợi',
      dataIndex: 'title',
      render: (text) => (
        <div className="t-name-ql">
          <div className="icon-svg"><CrownOutlined /></div>
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },

 

    {
      title: 'Mô tả quyền lợi dễ hiểu',
      dataIndex: 'description',
    },
  ];
  const columnsPolicies: TableColumnsType<BenefitApi.DataTypeBenefit> = [
    {
      title: () => (
        <Switch
          size='small'
          checked={isAllSelectedPolicies}
          onChange={handleSelectAllPolicies}
        />
      ),
      dataIndex: 'key',
      align: 'center',
      render: (key: number) => (
        <Switch
          size='small'
          checked={listBenefitPolicies.includes(key)}
          onChange={(checked) => handleSwitchChangePolicies(checked, key)}
        />
      ),
    },
    // {
    //   title: 'STT',
    //   dataIndex: 'stt',
    //   align: 'center',
    //   sorter: {
    //     compare: (a, b) => a.stt - b.stt,
    //     multiple: 1,
    //   },
    // },
    {
      title: 'Mã quyền lợi',
      dataIndex: 'code',
      render: (text) => (
        <div className="t-name-ql">
          <span className="neutral-gray-500 text-2-row">{text}</span>
        </div>
      ),
    },
    {
      title: 'Tên quyền lợi',
      dataIndex: 'title',
      render: (text) => (
        <div className="t-name-ql">
          <div className="icon-svg"><CrownOutlined /></div>
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },

    {
      title: 'Thương hiệu xe sở hữu',
      dataIndex: 'categoryCar',
      // minWidth: 180,
      // resizable: true,
      // flex: 1,
      render: (text) => (
        <Tooltip title={text} placement="topLeft">
          <div className="t-name-ql">
            <span className="neutral-gray-500 text-2-row">{text}</span>
          </div>
        </Tooltip>
      ),
    },
    
    {
      title: 'Mô tả quyền lợi dễ hiểu',
      dataIndex: 'description',
    },
  ];

  const getInfoCarePolicie = async (id: number) => {
    const result = await RankApi.getInfoCarePolicie(id);
    if (result.status) {
      // setDataInfoRank(result.data)
      form.setFieldValue('title', result.data.title)
      form.setFieldValue('brand', result.data.categoryCar?.map(item => item.id))
      form.setFieldValue('model', result.data.car?.map(item => item.id))
      form.setFieldValue('code', result.data.code)
      form.setFieldValue('dateStart', handleStringToDayJsV2(result.data.dateStart))
      form.setFieldValue('dateEnd', handleStringToDayJsV2(result.data.dateEnd))
      form.setFieldValue('quantity', result.data.totalOwnerVehicle)
      // setListBenefits(result.data.benefits.map(item => item.id))
      setListBenefitPolicies(result.data.benefitPolicies.map(item => item.id))
    } else {
      pushToast(result.message, "error", 2000)

    }
  }

  const gCLCategoryCar = async () => {
    const result = await getCLCategoryCar(undefined, undefined, permittedCategoryCarIds);
    if (result?.status) {
      setCLCategoryCar(fommatSelectOption(result.data))
    }
  }

  const gSLChildListCar = async () => {
    const result = await getSLChildListCar(cLCategoryCar.map(item => item.value));
    if (result?.status) {
      setCLListCar(fommatSelectOption(result.data))
    }
  }




  const getListBenefit = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const result = await BenefitApi.getListBenefit(pageSize, pageCurent, searchValue, undefined, 1);
    if (result?.status) {
      setDataBenefit(convertData(result.data))
      setPagination({ current: pageCurent, total: result.total, pageSize: pageSize })

    } else {
      pushToast(result?.message, 'error', 2000)
    }
  }, 500)


  const getListBenefitPolicies = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    const result = await BenefitApi.getListBenefitPolicies(pageSize, pageCurent, searchValuePolicies, undefined, 1);
    if (result?.status) {
      setDataBenefitPolicies(convertData(result.data))
      setPaginationPolicies({ current: pageCurent, total: result.total, pageSize: pageSize })

    } else {
      pushToast(result?.message, 'error', 2000)
    }
  }, 500)

  const convertData = (data: BenefitApi.IBenefit[]) => {
    var stt = 1;
    const convertData = data.map((item) => ({
      key: item.id,
      stt: stt++,
      code: item.code,
      title: item.title,
      description: item.description,
      categoryCar: item.categoryCar,
      status: item.status
    }))
    return convertData
  }

  const onChange = (key: string) => {
    setValueTab(key);
  };


  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    getListBenefit()
    getListBenefitPolicies()
  }, []);

  const onFinish = async (values: any) => {
    // if (!uploadedFile && !dataInfoRank?.icon) {
    //   pushToast('Vui lòng thêm hình!', 'error', 2000);
    //   return;
    // }
    const result = await RankApi.editCarePolicie(Number(id), values.title, values.code, values.brand, values.model, listBenefitPolicies, formatDateV2(values.dateStart), formatDateV2(values.dateEnd), values.quantity);
    if (result?.status) {
      pushToast(result.message, "success", 2000)
      navigator(-1)
      // getListRegions()
    } else {
      pushToast(result.message, "error", 2000)

    }
  };


  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;

    if (file) {
      const isLt1M = file.size / 1024 / 1024 < 1; // Kiểm tra xem kích thước tập tin có nhỏ hơn 1MB không
      if (!isLt1M) {
        pushToast('Ảnh phải nhỏ hơn 1MB!', 'error', 2000)

      } else {
        setUploadedFile(file);
      }
    }
  };

  const handleUploadClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };


  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>();

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>();
  const [selectedRowKeysPolicies, setSelectedRowKeysPolicies] = useState<React.Key[]>();

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[]) => {
      const numberArray: number[] = selectedRowKeys.map(key => Number(key));
      setListBenefits(numberArray);
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    getListBenefit(value)
  }

  const onSearchPolicies: SearchProps['onSearch'] = (value, _e, info) => {
    setSearchValuePolicies(value);
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    getListBenefit(pageNumber, pageSize)
  }

  const onPaginationChangePolicies: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    getListBenefitPolicies(pageNumber, pageSize)
  }



  const formatNumber2 = (num: string) => {
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const handleChangeNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\./g, '');
    if (!isNaN(Number(rawValue)) || rawValue === '') {
      setValueNumber(formatNumber2(rawValue));
    }
  };

  // useEffect(() => {
  //   getListBenefit()
  // }, [searchValue]);

  useEffect(() => {
    getListBenefitPolicies()
  }, [searchValuePolicies]);

  useEffect(() => {
    gSLChildListCar()
  }, [brand]);

  useEffect(() => {
    gCLCategoryCar()
    getInfoCarePolicie(Number(id))
  }, [])

  return (
    <div className="marketing-campaigns marketing-campaigns-detail add-rank-page">
      <Layout>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Cấu hình</a>,
            },
            {
              title: <a href="/">Quản lý phân hạng</a>,
            },
            {
              title: 'Chỉnh sửa chính sách CSKH',
            },
          ]}
        />

        <div className='title-page title-btn-back ctrl-title-vouche'>
          <Link to="/member-card/policy-management" className="icon-svg">
            <svg width="1em" height="1em" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6564 7.80321H4.04305L10.3955 2.37463C10.4971 2.28713 10.4354 2.12463 10.3012 2.12463H8.69582C8.62508 2.12463 8.55796 2.14963 8.50536 2.19428L1.65045 8.04963C1.58767 8.10321 1.53732 8.16944 1.50281 8.24385C1.4683 8.31825 1.45044 8.39909 1.45044 8.48088C1.45044 8.56268 1.4683 8.64352 1.50281 8.71792C1.53732 8.79233 1.58767 8.85856 1.65045 8.91213L8.54526 14.8032C8.57247 14.8264 8.60512 14.8389 8.63959 14.8389H10.2993C10.4336 14.8389 10.4953 14.6746 10.3937 14.5889L4.04305 9.16035H14.6564C14.7363 9.16035 14.8016 9.09606 14.8016 9.01749V7.94606C14.8016 7.86749 14.7363 7.80321 14.6564 7.80321Z" fill="currentColor" fillOpacity="0.88" />
            </svg>
          </Link>
          Chỉnh sửa chính sách CSKH
        </div>
        <div className="content-add-rank">
          <div className="form-add-rank">
            <div className="title-fz16-medium t-mb-18">Thiết lập thông tin</div>
            <Form
              className="form-block custom-page-css flex flex-col gap-2"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              // onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
              form={form}
            >

              {/* <Form.Item
                name="img"
                rules={[{ required: true, message: 'Vui lòng thêm hình!' }]}
              >
                <div className="input-block">
                  {
                    uploadedFile
                      ? (
                        <div className="avatar-uploader-block">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />
                          <img src={URL.createObjectURL(uploadedFile)} alt="Uploaded" className="avatar-uploader" onClick={handleUploadClick} />
                        </div>

                      ) : (
                        <div className="avatar-uploader-block">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                          />

                          <div className="avatar-uploader avatar-uploader-none-img" onClick={handleUploadClick}>
                            <div className="icon-svg"><PlusOutlined /></div>
                            <div className="text">Tải lên Icon <br /> của hạng</div>
                          </div>
                        </div>
                      )
                  }
                </div>
              </Form.Item> */}

              <Form.Item
                label="Mã chính sách CSKH"
                name="code"
                rules={[{ required: true, message: 'Mã chính sách không được để trống!' }]}
              >
                <Input placeholder="Vui lòng nhập mã chính sách" className='custom-input-css custom-page-css border ' />
              </Form.Item>

              <Form.Item
                label="Tên chính sách CSKH"
                name="title"
                rules={[{ required: true, message: 'Tên chính sách không được để trống!' }]}
              >
                <Input placeholder="Vui lòng nhập tên chính sách" className='custom-input-css custom-page-css border ' />
              </Form.Item>
              <Form.Item
                label="Số lượng xe sở hữu"
                name="quantity"
                rules={[
                  {
                    type: 'number',
                    min: 0,
                    max: 999999999,
                    transform: (value) => Number(value),
                    message: 'Số lượng xe phải lớn hơn hoặc bằng 0!',
                  },
                ]}
              >
                <Input
                  type='number'
                  min={0}
                  max={999999999}
                  placeholder="Vui lòng nhập số lượng xe" className='custom-input-css custom-page-css border '
                />
              </Form.Item>
              <Form.Item
                label="Thương hiệu xe sở hữu"
                name="brand"
                rules={[{ required: true, message: 'Thương hiệu xe không được để trống!' }]}
              >
                <Select
                  showSearch
                  mode="multiple"
                  allowClear
                  className="custom-page-css border rounded overflow-hidden "
                  variant="borderless"
                  placeholder="Chọn thương hiệu"
                  suffixIcon={null}
                  options={cLCategoryCar}
                  filterOption={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                // value={filterAccount.categoryCarId}
                // onChange={(e) => setFilterAccount({ ...dataFilterList, categoryCarId: e })}
                />
              </Form.Item>

              <Form.Item
                label="Tên xe sở hữu"
                name="model"
                rules={[{ required: true, message: 'Tên xe không được để trống!' }]}
              >
                <Select
                  showSearch
                  mode="multiple"
                  allowClear
                  className="custom-page-css border rounded overflow-hidden "
                  variant="borderless"
                  placeholder="Chọn tên xe"
                  suffixIcon={null}
                  options={cLListCar}
                  filterOption={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                // value={filterAccount.categoryCarId}
                // onChange={(e) => setFilterAccount({ ...dataFilterList, categoryCarId: e })}
                />
              </Form.Item>
              <Form.Item
                label={<span className="">Ngày bắt đầu<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                name="dateStart"
                rules={[{ required: true, message: 'Vui lòng chọn ngày bắt đầu!' }]}
              >
                <DatePicker
                  placeholder="Ngày bắt đầu"
                  className="custom-input-date w-full"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
              <Form.Item
                label={<span className="">Ngày kết thúc</span>}
                name="dateEnd"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const dateStart = getFieldValue('dateStart');

                      // Không chọn ngày kết thúc thì bỏ qua validate
                      if (!value || !dateStart) {
                        return Promise.resolve();
                      }

                      // Ngày kết thúc phải lớn hơn ngày bắt đầu
                      if (value.isAfter(dateStart, 'day')) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
                      );
                    },
                  }),
                ]}
              >
                <DatePicker
                  placeholder="Ngày kết thúc"
                  className="custom-input-date w-full"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
              <Form.Item>
                <div className="btn-block">
                  <Button className="btn btn-primary" type="primary" htmlType="submit">
                    <div className="text">
                      Cập nhật chính sách
                    </div>
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>

          <div className="detail-block t-mt-0">
            <Tabs
              defaultActiveKey={valueTab}
              items={[
                // {
                //   key: '1',
                //   label: <span className='text-base font-regular'>Quyền lợi hạng</span>,
                //   children:
                //     <TierBenefits
                //       dataBenefit={dataBenefit}
                //       onSearch={onSearch}
                //       columns={columns}
                //     />
                // },
                {
                  key: '2',
                  label: <span className='text-base font-regular'>Quyền lợi chính sách chăm sóc khách hàng</span>,
                  children:
                    <TierBenefits
                      dataBenefit={dataBenefitPolicies}
                      onSearch={onSearchPolicies}
                      columns={columnsPolicies}
                    />
                }
              ]}
              onChange={onChange} />


          </div>
        </div>
        <div className="custom-page-css w-full mt-auto">
          <ConfigProvider locale={viVN}>
            <div className="pagination-block">
              <Pagination
                className='rs-pagination'
                showSizeChanger
                current={valueTab === '1' ? pagination.current : paginationPolicies.current}
                pageSize={valueTab === '1' ? pagination.pageSize : paginationPolicies.pageSize}
                total={valueTab === '1' ? pagination.total : paginationPolicies.total}
                pageSizeOptions={['10', '20', '50', '100']}
                itemRender={(page, type, originalElement) => {
                  // Chỉ custom khi là nút số trang
                  if (type === 'page') {
                    return <span>{formatNumber(page)}</span>;
                  }
                  // prev / next / jump-prev / jump-next giữ nguyên
                  return originalElement;
                }}
                showTotal={(total) => `Tổng cộng ${dataPagination(valueTab === '1' ? pagination.total : paginationPolicies.total, valueTab === '1' ? pagination.pageSize : paginationPolicies.pageSize, valueTab === '1' ? pagination.current : paginationPolicies.current).totalPage} trang`}
                onChange={valueTab === '1' ? onPaginationChange : onPaginationChangePolicies}
              />
            </div>
          </ConfigProvider>
        </div>
      </Layout>
    </div>
  );
}

export default EditPolicyManagement;
